import { Component } from '@angular/core';
import {
  getDatabase,
  ref,
  onValue,
  query,
  limitToLast,
} from 'firebase/database';
import { initializeApp, deleteApp } from 'firebase/app';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-code',
  templateUrl: './code.component.html',
  styleUrl: './code.component.less',
})
export class CodeComponent {
  ide1: any;
  ide2: any;
  firebase: any;

  constructor() {
    const firebaseConfig = {
      apiKey: environment.NG_APP_FIREBASE_APIKEY,
      authDomain: environment.NG_APP_FIREBASE_AUTHDOMAIN,
      databaseURL: environment.NG_APP_FIREBASE_DATABASEURL,
      projectId: environment.NG_APP_FIREBASE_PROJECTID,
      storageBucket: environment.NG_APP_FIREBASE_STORAGEBUCKET,
      messagingSenderId: environment.NG_APP_FIREBASE_MESSAGINGSENDERID,
      appId: environment.NG_APP_FIREBASE_APPID,
      measurementId: environment.NG_APP_FIREBASE_MEASUREMENTID,
    };

    //init firebase
    this.firebase = initializeApp(firebaseConfig);
    const db = getDatabase();

    //get IDE 1 presence from firebase
    const ide1Pres = query(ref(db, 'presence/IDE 1/'), limitToLast(1));
    onValue(ide1Pres, (snapshot) => {
      snapshot.forEach((child) => {
        this.ide1 = child.val();
        this.ide1.timestamp = this.timechanded(
          this.ide1.timestamp,
          'counter_ide1',
        );
      });
    });

    //get IDE 2 presence from firebase
    const ide2Pres = query(ref(db, 'presence/IDE 2/'), limitToLast(1));
    onValue(ide2Pres, (snapshot) => {
      snapshot.forEach((child) => {
        this.ide2 = child.val();
        this.ide2.timestamp = this.timechanded(
          this.ide2.timestamp,
          'counter_ide2',
        );
      });
    });
  }

  ngOnDestroy(): void {
    deleteApp(this.firebase);
  }

  timechanded(startTime: number, id: string) {
    setInterval(function () {
      let counter = document.getElementById(id);
      var newDate = new Date().getTime();
      var finalDate = newDate - startTime * 1000 + 3600;

      var hours = Math.floor(
        (finalDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      var minutes = Math.floor(
        (finalDate % (1000 * 60 * 60)) / (1000 * 60),
      ).toLocaleString('de-DE', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      var seconds = Math.floor((finalDate % (1000 * 60)) / 1000).toLocaleString(
        'de-DE',
        { minimumIntegerDigits: 2, useGrouping: false },
      );

      if (counter) {
        counter.innerHTML = hours + ':' + minutes + ':' + seconds;
      }
    }, 1000);
  }
}
